import { writable } from "svelte/store";

export const helpCameraSettingsVisibleStore = writable(true);
export const helpWebRtcSettingsVisibleStore = writable<"pending" | "error" | "hidden">("hidden");
